import { defineMessages } from 'react-intl-next';

import DatabaseGIF from '../assets/database.gif';
import FolderSpaceGIF from '../assets/folder_space.gif';
import LivePageGIF from '../assets/live_page.gif';
import LoomGIF from '../assets/loom.gif';
import PageGIF from '../assets/page.gif';
import SmartLinkGIF from '../assets/smart_link.gif';
import WhiteboardsGIF from '../assets/whiteboards.gif';
import AifcGIF from '../assets/ai.gif';

import BlueBarSVG from '../assets/blueBar.svg';
import GreenBarSVG from '../assets/greenBar.svg';
import OrangeBarSVG from '../assets/orangeBar.svg';
import PurpleBarSVG from '../assets/purpleBar.svg';

const i18n = defineMessages({
	BlogTitle: {
		id: 'experiment-content-type-visuals-in-create.blog.title',
		defaultMessage: 'Blog to share ideas',
		description: 'Message that gets displayed in Spotlight header for blog',
	},
	BlogText: {
		id: 'experiment-content-type-visuals-in-create.blog.description',
		defaultMessage: 'Use blogs to publish and share ideas and thoughts with your team more widely.',
		description: 'Message that gets displayed in Spotlight message for blog',
	},
	DatabaseTitle: {
		id: 'experiment-content-type-visuals-in-create.database.title',
		defaultMessage: 'Organize and sync info',
		description: 'Message that gets displayed in Spotlight header for database',
	},
	DatabaseText: {
		id: 'experiment-content-type-visuals-in-create.database.description',
		defaultMessage: 'Use databases to track and sync information.',
		description: 'Message that gets displayed in Spotlight message for database',
	},
	FolderTitle: {
		id: 'experiment-content-type-visuals-in-create.folder.title',
		defaultMessage: 'Organize with folders',
		description: 'Message that gets displayed in Spotlight header for folder',
	},
	FolderText: {
		id: 'experiment-content-type-visuals-in-create.folder.description',
		defaultMessage: 'Use folders for a cleaner, more organized space.',
		description: 'Message that gets displayed in Spotlight message for folder',
	},
	LiveDocTitle: {
		id: 'experiment-content-type-visuals-in-create.live-doc.title',
		defaultMessage: 'Live Docs for collaboration',
		description: 'Message that gets displayed in Spotlight header for live docs',
	},
	LiveDocText: {
		id: 'experiment-content-type-visuals-in-create.live-doc.description',
		defaultMessage: 'Use live docs for quick collaboration and ideation.',
		description: 'Message that gets displayed in Spotlight message for live docs',
	},
	LoomTitle: {
		id: 'experiment-content-type-visuals-in-create.loom.title',
		defaultMessage: 'Record Loom updates',
		description: 'Message that gets displayed in Spotlight header for loom',
	},
	LoomText: {
		id: 'experiment-content-type-visuals-in-create.loom.description',
		defaultMessage:
			'Create Loom videos for walkthroughs of your work, quick async project updates, and more.',
		description: 'Message that gets displayed in Spotlight message for loom',
	},
	PageTitle: {
		id: 'experiment-content-type-visuals-in-create.page.title',
		defaultMessage: 'Share knowledge',
		description: 'Message that gets displayed in Spotlight header for page',
	},
	PageText: {
		id: 'experiment-content-type-visuals-in-create.page.description',
		defaultMessage: 'Use pages for publishing and sharing knowledge.',
		description: 'Message that gets displayed in Spotlight message for page',
	},
	SmartLinkTitle: {
		id: 'experiment-content-type-visuals-in-create.smart-link.title',
		defaultMessage: 'Embed Smart Links',
		description: 'Message that gets displayed in Spotlight header for smart link',
	},
	SmartLinkText: {
		id: 'experiment-content-type-visuals-in-create.smart-link.description',
		defaultMessage: 'Embed links directly in the content tree and access them anytime.',
		description: 'Message that gets displayed in Spotlight message for smart link',
	},
	SpaceTitle: {
		id: 'experiment-content-type-visuals-in-create.space.title',
		defaultMessage: 'Organize work in spaces',
		description: 'Message that gets displayed in Spotlight header for space',
	},
	SpaceText: {
		id: 'experiment-content-type-visuals-in-create.space.description',
		defaultMessage:
			'Use spaces for organizing work across a team, initiative, or however you like.',
		description: 'Message that gets displayed in Spotlight message for space',
	},
	WhiteboardTitle: {
		id: 'experiment-content-type-visuals-in-create.whiteboard.title',
		defaultMessage: 'Brainstorm as a team',
		description: 'Message that gets displayed in Spotlight header for whiteboard',
	},
	WhiteboardText: {
		id: 'experiment-content-type-visuals-in-create.whiteboard.description',
		defaultMessage: 'Use whiteboards to brainstorm on a blank canvas.',
		description: 'Message that gets displayed in Spotlight message for whiteboard',
	},
	AIText: {
		id: 'experiment-content-type-visuals-in-create.ai.description',
		defaultMessage: 'With a simple prompt, Rovo will draft a doc or whiteboard for you.',
		description: 'Message that gets displayed in Spotlight message for AI',
	},
});

export const CONTENT_TYPE_HOVER_CARD_CONTENT_MAPPING = {
	database: {
		text: i18n.DatabaseText,
		image: DatabaseGIF,
		barImage: GreenBarSVG,
	},
	folder: {
		text: i18n.FolderText,
		image: FolderSpaceGIF,
		barImage: PurpleBarSVG,
	},
	liveDoc: {
		text: i18n.LiveDocText,
		image: LivePageGIF,
		barImage: PurpleBarSVG,
	},
	loom: {
		text: i18n.LoomText,
		image: LoomGIF,
		barImage: OrangeBarSVG,
	},
	page: {
		text: i18n.PageText,
		image: PageGIF,
		barImage: OrangeBarSVG,
	},
	smartLink: {
		text: i18n.SmartLinkText,
		image: SmartLinkGIF,
		barImage: BlueBarSVG,
	},
	space: {
		text: i18n.SpaceText,
		image: FolderSpaceGIF,
		barImage: PurpleBarSVG,
	},
	whiteboard: {
		text: i18n.WhiteboardText,
		image: WhiteboardsGIF,
		barImage: BlueBarSVG,
	},
	ai: {
		text: i18n.AIText,
		image: AifcGIF,
		barImage: PurpleBarSVG,
	},
} as const;
export type ContentType = keyof typeof CONTENT_TYPE_HOVER_CARD_CONTENT_MAPPING;
